import { render } from "./PurchaseButton.vue?vue&type=template&id=6d31c882"
import script from "./PurchaseButton.vue?vue&type=script&lang=js"
export * from "./PurchaseButton.vue?vue&type=script&lang=js"

import "./PurchaseButton.vue?vue&type=style&index=0&id=6d31c882&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__